import {AUTHORIZED_USER, NOT_AUTHORIZED_USER} from "../actionType";

const initialState = {
    loading:false,
    loggedInState:false,
    userData:{

    }
};

const authorizationReducer = (state,action)=>{
    switch (action.type) {
        case AUTHORIZED_USER:
            return {
                ...initialState,
                ...action.payload
            }
        case NOT_AUTHORIZED_USER:
            return {
                ...initialState,
                ...action.payload
            }
        default: return initialState

    }
}

export default authorizationReducer;
